export const SELECT_DOCTOR_MODAL = "select-doctor-modal";
export const COMMENT_INFO_MODAL = "comment-info-modal";
export const BOOKING_INFO_MODAL = "booking-info";
export const TIMESLOT_DETIAL_MODAL = "timeslot-detail";
export const ASK_CREATE_TIMESLOT_MODAL = "ask-create-timeslot";
export const CHANGE_PRICE_MODAL = "change-price-modal";
export const EDIT_SCHEDULE_MODAL = "edit-schedule-modal";
export const FOLLOWUP_SCHEDULE_MODAL = "followup-schedule-modal";
export const DROPDOWN_MODAL = "dropdown-modal";
export const PAYMENT_MODAL = "payment-modal";
export const BIDDING_PRIZE_MODAL = "bidding-prize-modal";
export const REGISTER_UER_MODAL = "register-uer-modal";
export const COMMENT_RESPONSE_MODAL = "comment-response-modal";
export const PROFILE_PICTURE_MODAL = "profile-picture-modal";
export const GALLERY_IMAGE_MODAL = "gallery-image-modal";
export const ALGORITHM_MODAL = "algorithm-modal";
export const UPLOAD_PROFILE_IMAGE = "upload_profile_image";
